import { logError } from '../api/LoggerApi';
import { executeHttpRequest } from '../infra/HttpClient';

export function sendErrorToServer(errorInfo) {
  executeHttpRequest(logError(errorInfo));
}
